import { Link, isRouteErrorResponse, useRouteError } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { BrandMark } from "@/components/brand-mark";
import { ThemeToggle } from "@/components/theme-toggle";

export default function RouteErrorBoundary() {
  const error = useRouteError();
  const status = isRouteErrorResponse(error) ? error.status : 500;
  const message = isRouteErrorResponse(error)
    ? error.statusText || "Route error"
    : error instanceof Error
      ? error.message
      : "Something went wrong.";

  return (
    <div className="relative min-h-screen bg-background text-foreground bg-grain">
      <header className="flex items-center justify-between px-4 py-4 md:px-8 md:py-6">
        <BrandMark />
        <ThemeToggle />
      </header>
      <main className="mx-auto flex max-w-lg flex-col items-center px-6 pt-32 text-center">
        <div className="text-xs uppercase tracking-widest text-destructive">
          Error {status}
        </div>
        <h1 className="mt-2 font-display text-5xl font-black tracking-tight">
          Something broke.
        </h1>
        <p className="mt-3 max-w-md text-muted-foreground">{message}</p>
        <div className="mt-8 flex gap-3">
          <Button asChild variant="outline">
            <Link to="/">Home</Link>
          </Button>
          <Button onClick={() => window.location.reload()}>Reload</Button>
        </div>
      </main>
    </div>
  );
}
